export const pathname = "/menu";

export const page = {
  route(query: QueryParameters) {
    return { pathname: "/menu", query: { ...query, pageType: "menu" } };
  },
};
